import knicks from "./ticketFooterTexts/knicks";

type Dict = {
  [keys: string]: string | undefined;
};
const ticketFooterTexts: Dict = {
  knicks,
};

export default (tenantSubdomain: string) => {
  if (tenantSubdomain && ticketFooterTexts[tenantSubdomain]) {
    return ticketFooterTexts[tenantSubdomain];
  }
};
